var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAutorenew = function SvgIconAutorenew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 15.5h-3.75l5 5 5-5H25.5c0-5.525-4.475-10-10-10a9.914 9.914 0 0 0-5.325 1.55L12 8.875A7.338 7.338 0 0 1 15.5 8c4.137 0 7.5 3.363 7.5 7.5Zm-2.175 8.45L19 22.125a7.523 7.523 0 0 1-3.5.875A7.506 7.506 0 0 1 8 15.5h3.75l-5-5-5 5H5.5c0 5.525 4.475 10 10 10a9.914 9.914 0 0 0 5.325-1.55Z",
    fill: "#fff"
  })));
};
export default SvgIconAutorenew;